import ExpandableRowMobile from './ExpandableRowMobile';
import { withI18n } from 'react-i18next';

export default withI18n()(ExpandableRowMobile);
